import styled from 'styled-components';

import { theme } from '../../global-styles/colors';

export const CounterStyle = styled.div`
  display: flex;
  align-items: center;
  &:focus {
    outline: unset;
  }

  .counter-label {
    margin-right: 16px;
    flex: auto;
  }
  .counter-form-button {
    border-radius: 6px;
    background: ${(props) => props.theme.primary.primary10};
    color: ${(props) => props.theme.primary.primary50};
    width: 32px;
    height: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    &.disabled {
      background: ${theme.divider_and_border.body_divider};
      color: ${theme.type.secondary};
      pointer-events: none;
    }
  }
  .counter-form {
    align-items: center;
    display: flex;
    &__number {
      width: 32px;
      margin: 0 8px;
      text-align: center;
    }
  }
`;
